import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

import type { ImageWithButtonDiv } from '../type';

export const MobileImageWrapper = styled.picture`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding-bottom: 80px;

  img {
    position: unset !important;
  }

  ${DESKTOP} {
    display: none;
  }
`;

export const UnderTitleWrapper = styled.section`
  display: none;

  ${DESKTOP} {
    display: flex;
    justify-content: space-between;
    gap: 60px;
    width: 100%;
    max-width: 820px;
    margin: 0 auto;
  }
`;

export const BottomCenterWrapper = styled.section`
  display: none;

  ${DESKTOP} {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px 0;
    max-width: 820px;
    margin: 0 auto;
  }
`;

export const DesktopImageWrapper = styled.picture<{
  width?: string;
  height?: string;
}>`
  display: none;

  @media (min-width: 1040px) {
    display: block;
    ${({ width }) => (!width ? 'flex: 1' : '')};
    width: ${({ width }) =>
      width ? ` calc(820px - 60px - ${width}px)` : '100%'};
    height: max-content;

    img {
      position: unset !important;
      width: ${({ width }) =>
        width ? ` calc(820px - 60px - ${width}px)` : '100%'} !important;
      height: fit-content !important;
    }
  }
`;

export const SecondDesktopImageWrapper = styled.picture<{
  width?: string;
  height?: string;
}>`
  display: none;

  @media (min-width: 1040px) {
    display: block;
    ${({ width }) => (!width ? 'flex: 1' : '')};
    width: ${({ width }) => (width ? `${width}px` : '100%')};
    height: ${({ height }) => (height ? `${height}px` : 'auto')};

    img {
      position: unset !important;
      width: ${({ width }) => (width ? `${width}px` : '100%')} !important;
      height: ${({ height }) => (height ? `${height}px` : 'auto')} !important;
    }
  }
`;

const Button = css`
  min-width: 70px;
  padding: 11px 19px;
  ${bodyB};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
  border: none;
  border-radius: 8px;
  line-height: normal;
  cursor: pointer;
`;

const SCC = css`
  ${Button};
  color: white !important;
  background-color: ${vars.pink[70]};
`;

export const DarkGray = css`
  ${Button};
  color: ${vars.neutral[10]} !important;
  background-color: ${vars.neutral[70]};
  border: 1px solid ${vars.neutral[30]};
`;

export const White = css`
  ${Button};
  color: ${vars.neutral[80]} !important;
  background-color: ${vars.neutral[0]};
  border: 1px solid ${vars.neutral[30]};
`;

const buttonStyle = {
  scc: SCC,
  darkGray: DarkGray,
  white: White,
};

const buttonTopMargin = {
  underTitle: '0',
  bottomCenter: '40px',
};

export const CustomButtonWrapper = styled.button<{
  button: ImageWithButtonDiv['button'];
}>`
  ${({ button }) => buttonStyle[button.style] ?? buttonStyle.scc};
  margin: ${({ button }) =>
      buttonTopMargin[button.position] ?? buttonTopMargin.bottomCenter}
    auto 0;

  @media (min-width: 1040px) {
    margin: ${({ button }) =>
        buttonTopMargin[button.position] ?? buttonTopMargin.bottomCenter}
      0 0;
  }
`;
